class CodeError {
    codeExerciseId: string = "";
    lineNumber: string = "";
    message: string = "";
}

export { CodeError };